import { ExploreSingleInsight } from '@api';
import { RangeHorizon } from '@chart';
import { BaseErrorView } from '@terminal/components/base-error-view/BaseErrorView';
import { InsightsList } from '@terminal/components/insights-group/insights-list/InsightsList';
import { IconConfig } from '@terminal/components/insights-legacy-drawer/ScenarioInsightsLegacyDrawer';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './InsightsGroup.module.scss';

export interface InsightsGroupProps {
  horizon: RangeHorizon;
  activeInsightId: string;
  selectedInsights: ExploreSingleInsight[];
  isError: boolean;
  isInsightsLoading: boolean;
  handleSetActiveInsightId: (insightId: string) => void;
  handleSetIconConfig?: (config: IconConfig) => void;
}

export const InsightsGroup = ({
  horizon,
  activeInsightId = '',
  selectedInsights,
  isError,
  isInsightsLoading,
  handleSetActiveInsightId,
  handleSetIconConfig,
}: InsightsGroupProps) => {
  const { t } = useTranslation(['insights']);

  const renderCards = () => {
    if (isError) {
      return <BaseErrorView className={styles.styledBaseErrorView} />;
    }

    return (
      <InsightsList
        activeInsightId={activeInsightId}
        selectedInsights={selectedInsights}
        isInsightsLoading={isInsightsLoading}
        handleSetActiveInsightId={handleSetActiveInsightId}
        handleSetIconConfig={handleSetIconConfig}
      />
    );
  };

  return (
    <div className={styles.insightsGroupRoot}>
      <div className={styles.header}>
        <h4 className={styles.title}>
          {t('insights:insightsGroup.title', {
            horizon: t(`insights:insightsGroup.${horizon}`),
          })}
        </h4>
        <span className={styles.text}>
          {t('insights:insightsGroup.mostRecentFirst')}
        </span>
      </div>
      {renderCards()}
    </div>
  );
};
